export const GET_OFFERS = "GET_OFFERS";
